export default __webpack_public_path__ + "static/mobile_sek2_KV04-feb992d255f56b055f3ac560559dae1b.mp4";